import SupplierListViewModel from "../view/supplierlistviewmodel";
import PagedElements from "./pagedelements";

export default class PagedSuppliers extends PagedElements<SupplierListViewModel> {
    constructor(init?: Partial<PagedSuppliers>) { super(init); }
}